<div class="tab-container" [ngClass]="{ useMargin: useMargin }">
	@for (tab of tabs; track $index) {
	<div
		class="tab"
		[ngClass]="{ active: activeTab === tab, mini: mini }"
		(click)="setActiveTab(tab)"
	>
		{{ mini ? tab.name : tab.display }}
	</div>
	}
</div>
